//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const GENDER = {
    '男': 'male',
    '女': 'female'
}
export default {
    props: {
        data: Object
    },
    computed: {
        gender () {
            return this.data && GENDER[this.data.gender] || 'male'
        },
        desc_len () {
            return [this.data.gender, this.data.city].filter(v => v && v != '未知').length
        }
    },
    methods: {
        hide () {
            return this.$emit('hide')
        }
    }
}
